import React, { useState } from "react";
import { switchMap } from "rxjs/operators";
import PropTypes from "prop-types";
import xstream from "state-x-stream";
import Track from "../../models/Track";
import Filter from "../../../../models/Filter";
import Btn from "../../../../components/atoms/Btn";

const controller = ({ props$ }) => {
  function applyFilters(updated) {
    props$.value.track.applyFilters(updated);
  }

  function applyHighlight(filter) {
    props$.value.track.applyHighlightFilters(filter);
  }

  return {
    filters: props$.pipe(switchMap(({ track }) => track.filtersUpdated$)),
    applyFilters,
    applyHighlight,
  };
};

function TrackFilters({ filters, track, applyFilters, applyHighlight }) {
  const [isVisible, toggleFilters] = useState(false);
  const iconClass = isVisible
    ? "fa fa-chevron-up tw-pl-2"
    : "fa fa-filter tw-pl-2";

  if (!filters || !track.FilterRenderer) return null;

  return (
    <div
      className={`tw-absolute tw--top-5 tw-right-5 color-2 tw-rounded ${
        isVisible
          ? "tw-z-30 tw-border border-2"
          : "tw-border tw-border-transparent"
      }`}
    >
      <div className="tw-absolute tw-inset-0 bg-2 tw-opacity-70 tw--z-10" />

      <div className="tw-relative prevent-zoom">
        <div className="tw-w-full tw-right-0 tw-top-0 tw-text-2xs tw-text-right">
          <Btn
            className="tw-flex tw-items-center tw-justify-center"
            onSubmit={() => toggleFilters(!isVisible)}
            title="toggle filters"
          >
            <div className="tw-flex-grow" />
            <div className="tw-opacity-70 tw-font-semibold">FILTERS</div>
            <i className={`${iconClass} tw--mt-1 tw-w-4`} />
            <div className="tw-w-2" />
          </Btn>
        </div>

        {isVisible ? (
          <div className="tw-border-t border-2 tw-px-2 tw-py-1 backdrop-filter-blur-md">
            <track.FilterRenderer
              filters={filters}
              applyFilters={applyFilters}
              applyFilterHighlight={applyHighlight}
            />
          </div>
        ) : null}
      </div>
    </div>
  );
}

TrackFilters.propTypes = {
  applyFilters: PropTypes.func.isRequired,
  applyHighlight: PropTypes.func.isRequired,
  track: PropTypes.instanceOf(Track).isRequired,
  filters: PropTypes.oneOfType([
    PropTypes.shape({}),
    PropTypes.arrayOf(PropTypes.instanceOf(Filter)),
  ]),
};

TrackFilters.defaultProps = {
  filters: null,
};

export default xstream(controller)(TrackFilters);
